// import { localDatabaseUrls } from "../../backend/constants";


// const validFilePrefixes = [
//     localDatabaseUrls.serviceURL.originalFilePrefix,
//     localDatabaseUrls.serviceURL.obsoleteString,
//     localDatabaseUrls.serviceURL.processString,
//     localDatabaseUrls.serviceURL.costFilePrefix,
//     localDatabaseUrls.serviceURL.originalFilePrefixSvc,
//     localDatabaseUrls.serviceURL.errorFileSvc,
//     localDatabaseUrls.serviceURL.errorReportFilePrefix,
// ];


const getFileXlsx = async (fileName, response, downloadFile) => {
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    // debugger;
    const link = document.createElement('a');
    // const downloadFileTypeName = validFilePrefixes.includes(downloadFile)
    //     ? downloadFile+"_" +""
    //     : "error-report-";
    link.href = downloadUrl;
    link.download = `${fileName}`;
    // link.download = `${downloadFileTypeName}${fileName}`; commenting this as req is complete filename shuld be present
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
}

const getTemplateFileXlsx = async (response, fileNameFromResponse) => {
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${fileNameFromResponse}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
}

export { getFileXlsx, getTemplateFileXlsx }